export var Cond;
(function (Cond) {
    let Type;
    (function (Type) {
        Type["AtMost"] = "AT_MOST";
        Type["AtLeast"] = "AT_LEAST";
        Type["Between"] = "BETWEEN";
        Type["Match"] = "MATCH";
        Type["Selection"] = "SELECTION";
        Type["ByField"] = "BY_FIELD";
        Type["ByFormula"] = "BY_FORMULA";
        Type["TopByField"] = "TOP_BY_FIELD";
        Type["TopByFormula"] = "TOP_BY_FORMULA";
        Type["RelativeDate"] = "RELATIVE_DATE";
    })(Type = Cond.Type || (Cond.Type = {}));
    let Operator;
    (function (Operator) {
        Operator["Equals"] = "=";
        Operator["NotEquals"] = "<>";
        Operator["LessThan"] = "<";
        Operator["LessThanOrEqual"] = "<=";
        Operator["GreaterThan"] = ">";
        Operator["GreaterThanOrEqual"] = ">=";
    })(Operator = Cond.Operator || (Cond.Operator = {}));
    let TopOperator;
    (function (TopOperator) {
        TopOperator["Top"] = "TOP";
        TopOperator["Bottom"] = "BOTTOM";
    })(TopOperator = Cond.TopOperator || (Cond.TopOperator = {}));
    let TopSequence;
    (function (TopSequence) {
        TopSequence["FirstIsolate"] = "FIRST_ISOLATE";
        TopSequence["LastIsolate"] = "LAST_ISOLATE";
    })(TopSequence = Cond.TopSequence || (Cond.TopSequence = {}));
    let Selection;
    (function (Selection) {
        let Mode;
        (function (Mode) {
            Mode["All"] = "ALL";
            Mode["Include"] = "INCLUDE";
            Mode["Exclude"] = "EXCLUDE";
            Mode["ExcludeAll"] = "EXCLUDE_ALL";
        })(Mode = Selection.Mode || (Selection.Mode = {}));
        function make(mode, selected) {
            return {
                mode,
                selected,
                type: "SELECTION",
            };
        }
        Selection.make = make;
    })(Selection = Cond.Selection || (Cond.Selection = {}));
    let Match;
    (function (Match) {
        let Mode;
        (function (Mode) {
            Mode["Include"] = "INCLUDE";
            Mode["Exclude"] = "EXCLUDE";
        })(Mode = Match.Mode || (Match.Mode = {}));
        let Case;
        (function (Case) {
            Case["Sensitive"] = "SENSITIVE";
            Case["Insensitive"] = "INSENSITIVE";
        })(Case = Match.Case || (Match.Case = {}));
        function make(mode, pattern, caseType = "SENSITIVE") {
            return {
                mode,
                pattern,
                case: caseType,
                type: "MATCH",
            };
        }
        Match.make = make;
    })(Match = Cond.Match || (Cond.Match = {}));
    let ByField;
    (function (ByField) {
        function make(field, operator, operand) {
            return { field, operator, operand, type: "BY_FIELD" };
        }
        ByField.make = make;
    })(ByField = Cond.ByField || (Cond.ByField = {}));
    let TopByField;
    (function (TopByField) {
        function make(field, operator, sequence, limit) {
            return {
                type: "TOP_BY_FIELD",
                field,
                operator,
                sequence,
                limit,
            };
        }
        TopByField.make = make;
    })(TopByField = Cond.TopByField || (Cond.TopByField = {}));
    let AtMost;
    (function (AtMost) {
        function make(value, opts = {}) {
            const include = {
                max: opts.max === true ? true : false,
                nulls: opts.nulls === true ? true : false,
            };
            return { value, include, type: "AT_MOST" };
        }
        AtMost.make = make;
    })(AtMost = Cond.AtMost || (Cond.AtMost = {}));
    let AtLeast;
    (function (AtLeast) {
        function make(value, opts = {}) {
            const include = {
                min: opts.min === true ? true : false,
                nulls: opts.nulls === true ? true : false,
            };
            return { value, include, type: "AT_LEAST" };
        }
        AtLeast.make = make;
    })(AtLeast = Cond.AtLeast || (Cond.AtLeast = {}));
    let Between;
    (function (Between) {
        function make(min, max, opts = {}) {
            const include = {
                min: opts.min === true ? true : false,
                max: opts.max === true ? true : false,
                nulls: opts.nulls === true ? true : false,
            };
            return { min, max, include, type: "BETWEEN" };
        }
        Between.make = make;
    })(Between = Cond.Between || (Cond.Between = {}));
})(Cond || (Cond = {}));
